module.exports = __webpack_public_path__ + "fonts/notosans-regular-webfont.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Noto_Sans/notosans-regular-webfont.woff2
// module id = 3443
// module chunks = 0